(() => {
  const money = (cents, currency) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD'
  }).format((Number(cents) || 0) / 100);

  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  document.querySelectorAll('[data-tsdp-root]').forEach((root) => {
    root.dataset.tsdpReady = 'true';
    const variantsNode = root.querySelector('[data-tsdp-variants]');
    if (!variantsNode) return;

    const variants = JSON.parse(variantsNode.textContent || '[]');
    const currency = root.dataset.currency || 'USD';
    const colorIndex = Number(root.dataset.colorIndex || 0);
    const sizeIndex = Number(root.dataset.sizeIndex || 1);
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const submit = root.querySelector('[data-add-to-cart]');
    const colorButtons = [...root.querySelectorAll('[data-color-value]')];
    const sizeButtons = [...root.querySelectorAll('[data-size-value]')];
    const figures = [...root.querySelectorAll('[data-gallery-color]')];

    let color = root.dataset.initialColor || colorButtons[0]?.dataset.colorValue || '';
    let size = root.dataset.initialSize || sizeButtons[0]?.dataset.sizeValue || '';

    const variantsForColor = () => variants.filter((variant) => variant.options[colorIndex] === color);
    const matchingVariant = () => variants.find((variant) => variant.options[colorIndex] === color && variant.options[sizeIndex] === size);

    const showGallery = () => {
      const wanted = normalize(color);
      const seen = new Set();
      figures.forEach((figure) => {
        const matches = figure.dataset.galleryColor === wanted;
        const role = figure.dataset.galleryRole || 'detail';
        const show = matches && !seen.has(role);
        figure.hidden = !show;
        if (show) seen.add(role);
      });
      root.querySelectorAll('[data-gallery-label]').forEach((label) => {
        label.textContent = color;
      });
    };

    const refreshSizes = () => {
      const available = variantsForColor();
      sizeButtons.forEach((button) => {
        const option = available.find((variant) => variant.options[sizeIndex] === button.dataset.sizeValue);
        button.disabled = !option || !option.available;
      });

      const current = available.find((variant) => variant.options[sizeIndex] === size && variant.available);
      if (!current) {
        const next = available.find((variant) => variant.available);
        if (next) size = next.options[sizeIndex];
      }
    };

    const render = () => {
      refreshSizes();
      const variant = matchingVariant();

      colorButtons.forEach((button) => {
        const selected = button.dataset.colorValue === color;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      sizeButtons.forEach((button) => {
        const selected = button.dataset.sizeValue === size;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      if (variant) {
        idInput.value = variant.id;
        price.textContent = money(variant.price, currency);
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'ADD TO CART — KEEP ROLLING' : 'CURRENTLY UNAVAILABLE';
      }

      showGallery();
    };

    colorButtons.forEach((button) => button.addEventListener('click', () => {
      color = button.dataset.colorValue;
      render();
    }));
    sizeButtons.forEach((button) => button.addEventListener('click', () => {
      size = button.dataset.sizeValue;
      render();
    }));

    render();
  });
})();
